export default {
  // This is the list of languages your application supports
  supportedLngs: ["es", "en", "pt-BR"],
  defaultNS: "index",
  fallbackLng: "es",
  react: { useSuspense: false },
};
